import { render, staticRenderFns } from "./myPoints.vue?vue&type=template&id=5fb775ed&scoped=true&"
import script from "./myPoints.vue?vue&type=script&lang=js&"
export * from "./myPoints.vue?vue&type=script&lang=js&"
import style0 from "./myPoints.vue?vue&type=style&index=0&id=5fb775ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb775ed",
  null
  
)

export default component.exports